import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/workOrder/${number | ':workOrderId'}/hasOverlaps`;

export const ROUTE: RouteDefinition = `${baseRoute}/workOrder/:workOrderId/hasOverlaps`;

export const URL = (hasOverlaps: number): RouteDefinition =>
	`${baseRoute}/workOrder/${hasOverlaps}/hasOverlaps`;
